import(/* webpackMode: "eager" */ "/home/liamto-agesco-conseils/www/apps/front/src/app/[lng]/error.tsx");
